import '../../../scss/pages/service/main.scss';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../utilities/analytics';
import type { ITrackingPayload } from '../../types/analytics';

const observeElement = (selector: string, threshold = 0) => {
    const element = document.querySelector(selector);

    if (!element) return;

    const observer = new IntersectionObserver(
        ([entry], obs) => {
            const { isIntersecting, target } = entry;
            if (isIntersecting) {
                target?.classList.add('fade-in-slide');
                obs.unobserve(target);
            }
        },
        { threshold },
    );

    observer.observe(element);
};

// Add observers
observeElement('#banner');
observeElement('#repair-pal');
observeElement('#carmax-service', 0.2);
observeElement('#hit-the-road');
observeElement('#maxcare-apps');
observeElement('#disclaimers');

export const openStoreSelectionModal = () => {
    const nearestStore = localStorage.getItem('kmx-nearest-store') as string;
    const zipCode = JSON.parse(nearestStore)?.store?.ZipCode || '';
    const detail = { stateOrZip: zipCode };
    const event = new CustomEvent('kmxOpenStoreSelectionModal', { detail });
    document.documentElement.dispatchEvent(event);
};

// Add event listener
const element = document.querySelector('#change-store') as HTMLButtonElement;
element?.addEventListener('click', openStoreSelectionModal);

element?.addEventListener('keydown', (event) => {
    if ((event as KeyboardEvent).key === 'Enter') {
        setTimeout(() => {
            element.click();
        }, 0);
    }
});

// Add event listener for app badge clicks
const appBadges = document.querySelectorAll('a.mobile-apps--badge-link') as NodeListOf<HTMLAnchorElement>;
appBadges.forEach((badge) => {
    badge.addEventListener('click', () => {
        const name = badge.dataset.type ?? badge.textContent?.trim() ?? 'App';
        const payload: ITrackingPayload = {
            event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
            linkDetails: { name, position: 'apps' },
            pageInfo: { pageName: 'Service' },
        };
        trackEDDL(payload);
    });
});
